<template>
    <div class="loginPanel">
        <el-card class="box-card">
            <!-- <div style="text-align:center; margin-bottom: 16px"><img src="logo" class="logo"></div> -->
            <div style="text-align:center; margin-bottom: 16px">鹏龙天创MRO</div>
            <el-form ref="form" :model="form" >
                <el-form-item>
                    <el-autocomplete
                        prefix-icon="el-icon-house"
                        v-model="form.company"
                        :fetch-suggestions="querySearchCompany"
                        placeholder="请输入公司"
                        style="width: 100%;"
                    ></el-autocomplete>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="form.email" placeholder="请输入邮件地址" prefix-icon="el-icon-user" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="form.password" placeholder="请输入密码" prefix-icon="el-icon-lock" show-password clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit" style="width: 100%">登录</el-button>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<script>
import  JSEncrypt  from 'jsencrypt'
export default {
    name: "login",
    data() {
        return {
            form: {
                company: "",
                email: "",
                password: "",
            }
        }
    },
    methods: {
        onSubmit() {
            const encryptor = new JSEncrypt ()
            // encryptor.default_algorithm = 'RSA'
            encryptor.setPublicKey("MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDizPaxvnEHlxWMXVM9nFrxWv1i8rP4l8plTZ2+p89ax3bQBPqLvPD7GApp0m5+H56ejpdJR7JXmcWemgEPPVWMFnTDJHi+MG7wM0uZZvLAokM+WiBLXekfEIDm1KJV1w/CD6W8zpFJVhFMe4icgDpeMN1T4FAlJbyk0ayn2vYm+wIDAQAB")
            const email = encryptor.encrypt(this.form.email)
            const password = encryptor.encrypt(this.form.password)
            const params = {company: this.form.company, email: email, password: password}
            let _this = this;
            this.$axios.post("/admin/login", params)
            .then(response => {
                let resp = response.data;
                if(resp.header.status == 0) {
                    _this.$store.commit("login", true)
                    _this.$store.commit("setUserInfo", resp.data);
                    _this.$router.push("/workspace")
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
            }).catch(()=>{
                _this.$notify.error({
                    title: '错误',
                    message: "登录失败，请稍候再试"
                });
            })
        },
        querySearchCompany(queryString, cb) {
            if(queryString) {
                this.$axios.get("/admin/companies/"+queryString)
                .then(response => {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        cb(resp.data.map(it => {
                            return {
                                value: it,
                            };
                        }));
                    }
                }).catch(()=>{
                })
            }
        },
    },
}
</script>

<style>
    .loginPanel {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background: url(/img/bg.jpg);
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
    .box-card {
        width: 360px;
    }
    .logo {
        width: 100px;
        height: 30px;
        margin: 0 auto;
    }
</style>
